'use client';

import { LinkPlugin } from '@platejs/link/react';

import { LinkElement, LinkFloatingToolbar } from 'features/Editor';

export const LinkKit = [
	LinkPlugin.configure({
		render: {
			node: LinkElement,
			afterEditable: () => <LinkFloatingToolbar />,
		},
	}),
];
